import { render, staticRenderFns } from "./Rechnungsnummer.vue?vue&type=template&id=95786c24&"
import script from "./Rechnungsnummer.vue?vue&type=script&lang=js&"
export * from "./Rechnungsnummer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports